import makeStyles from '@mui/styles/makeStyles';
import {
  checkboxLabel,
  hintStrip,
  stepContainer
} from '../../../shared/ui/styles';

// Figma 10:182 (associate-to-existing credentials): the "MSSP Child tenant
// detected" box stays on top with 32px below it, sections are 24px apart
// and the confirm checkbox uses the 14/19 body style.
export const createClasses = makeStyles(theme => ({
  container: {
    ...stepContainer(theme),
    gap: theme.spacing(3)
  },
  warningBox: {
    marginBottom: theme.spacing(1)
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '21px'
  },
  uuidHint: {
    ...hintStrip(theme),
    marginTop: theme.spacing(1)
  },
  checkboxLabel: {
    ...checkboxLabel(theme),
    '& p': {
      fontSize: '14px',
      lineHeight: '19px',
      color: theme.palette.primary[500]
    }
  }
}));
